export default __webpack_public_path__ + "static/media/amico.d1707430.png";